import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Constants from 'js/Constants';
import { updateFormData } from 'js/actions';
import { FORM_TYPE_CREATE_REUSABLE_TX } from 'js/constants/formTypes';
import { TransformType } from 'new/components/ReusableTransform/types';
import { getNewSelectionValue } from 'js/components/elements/rselect/ReactSelectUtils';
import {
  LANGUAGE_DEFAULTS,
  RECORD_LANGUAGE_DEFAULTS,
} from 'js/components/reusableTransforms/form/TxFormConstants';

export function getCodeLanguageFormData(
  type: string = TransformType.RECORD,
  languageSelected = 'python',
) {
  let languageDefaults =
    type === TransformType.RECORD ? RECORD_LANGUAGE_DEFAULTS : LANGUAGE_DEFAULTS;

  let newCodeLanguage = getNewSelectionValue(
    { label: languageSelected, value: languageSelected },
    true,
    'python',
  );

  return {
    codeLanguage: newCodeLanguage,
    code: languageDefaults[newCodeLanguage],
  };
}

export const useSelectedEditorLanguage = (language: string, transformType: TransformType) => {
  const dispatch = useDispatch();

  const current = Constants.EditorModeByLanguage[language]?.name;
  const isPythonCode =
    current === Constants.EditorModeByLanguage[Constants.CodeLanguages.PYTHON].name;
  const isJavascriptCode =
    current === Constants.EditorModeByLanguage[Constants.CodeLanguages.JAVASCRIPT].name;
  const isNexlaJSON = current === Constants.EditorModeByLanguage[Constants.CodeLanguages.JOLT].name;

  const changeCodeLanguageSelection = (language: string) => {
    const formData = getCodeLanguageFormData(transformType, language);
    dispatch(updateFormData(FORM_TYPE_CREATE_REUSABLE_TX, formData));
  };

  const switchToJS = () => changeCodeLanguageSelection(Constants.CodeLanguages.JAVASCRIPT);
  const switchToNexlaJSON = () => changeCodeLanguageSelection(Constants.CodeLanguages.JOLT);
  const switchToPython = () => changeCodeLanguageSelection(Constants.CodeLanguages.PYTHON);

  return useMemo(
    () => ({
      isPythonCode,
      switchToPython,
      isJavascriptCode,
      switchToJS,
      isNexlaJSON,
      switchToNexlaJSON,
    }),
    [language],
  );
};
